import CRM from '../../pages/CRM';
import type { Customer } from '../../lib/customers';

interface CrmEmbeddedCreateOpportunityModalProps {
  pipelineId?: number | null;
  /** Pre-fill the customer on the new-opportunity drawer. */
  initialCustomer?: Customer | null;
  onClose: () => void;
  onCreated?: () => void;
}

/** Hosts the CRM new-opportunity drawer on top of the control centre (no route change). */
export default function CrmEmbeddedCreateOpportunityModal({
  pipelineId = null,
  initialCustomer = null,
  onClose,
  onCreated,
}: CrmEmbeddedCreateOpportunityModalProps) {
  return (
    <CRM
      embedCreateOpportunity
      embedPipelineId={pipelineId}
      embedInitialCustomer={initialCustomer}
      hidePageChrome
      onEmbedClose={onClose}
      onEmbedOpportunityChange={onCreated}
    />
  );
}
